import {
  CREATE_FILE_REFERENCE_REQUEST,
  CREATE_FILE_REFERENCE_SUCCESS,
  CREATE_FILE_REFERENCE_FAILURE,

  DELETE_FILE_REFERENCE_REQUEST,
  DELETE_FILE_REFERENCE_SUCCESS,
  DELETE_FILE_REFERENCE_FAILURE,

  FIND_FILE_REFERENCES_REQUEST,
  FIND_FILE_REFERENCES_SUCCESS,
  FIND_FILE_REFERENCES_FAILURE,

  SEARCH_FILE_REFERENCES_REQUEST,
  SEARCH_FILE_REFERENCES_SUCCESS,
  SEARCH_FILE_REFERENCES_FAILURE,

  UPDATE_FILE_REFERENCE_REQUEST,
  UPDATE_FILE_REFERENCE_SUCCESS,
  UPDATE_FILE_REFERENCE_FAILURE,

  FIND_FILE_REFERENCE_REQUEST,
  FIND_FILE_REFERENCE_SUCCESS,
  FIND_FILE_REFERENCE_FAILURE,


  LOGOUT_USER,
  AUTHENTICATE_FAILURE,
} from 'Redux/Action';
import {
  removeOpenRequest,
  removeFailedRequest,
  addSingleObjectToReducer,
  getSingleObject
}                  from 'ClientService/ReducerUtil';
import { Reducer } from 'redux';
import {
  FileReferenceState,
  TFileReferenceState
}                  from 'Redux/Store/FileReference/FileReferenceState';

const initialState = FileReferenceState.getInitialState();

export const fileReferenceReducer: Reducer<TFileReferenceState> = (state = initialState, action) => {

  switch (action.type) {

    case AUTHENTICATE_FAILURE :
    case LOGOUT_USER :
      return {
        ...initialState,
      };

    case CREATE_FILE_REFERENCE_REQUEST:
    case DELETE_FILE_REFERENCE_REQUEST:
    case UPDATE_FILE_REFERENCE_REQUEST:
    case FIND_FILE_REFERENCE_REQUEST:
    case FIND_FILE_REFERENCES_REQUEST:
    case SEARCH_FILE_REFERENCES_REQUEST:
      return {
        ...state,
        lastInteractiveId: null,
        openRequests     : [ ...state.openRequests, action.type ],
        failedRequests   : removeFailedRequest(action, state),
        updatedAt        : Date.now(),
      };

    case CREATE_FILE_REFERENCE_SUCCESS:
    case UPDATE_FILE_REFERENCE_SUCCESS:
    case FIND_FILE_REFERENCE_SUCCESS:
      const entry = getSingleObject(action.payload);

      return {
        ...state,
        lastInteractiveId: entry.id,
        openRequests     : removeOpenRequest(action, state),
        updatedAt        : Date.now(),
        fileReference    : {
          ...state.fileReference,
          entries: addSingleObjectToReducer(state.fileReference.entries, entry)
        },
      };

    case FIND_FILE_REFERENCES_SUCCESS:
      return {
        ...state,
        openRequests : removeOpenRequest(action, state),
        fileReference: {
          entries : action.payload.fileReferences,
          maxCount: (action.meta) ? action.meta.response.count : state.fileReference.maxCount,
        },
        updatedAt    : Date.now(),
      };

    case SEARCH_FILE_REFERENCES_SUCCESS:
      return {
        ...state,
        openRequests : removeOpenRequest(action, state),
        searchEntries: {
          ...state.searchEntries,
          ...action.payload.fileReferences,
        },
        updatedAt    : Date.now(),
      };

    case DELETE_FILE_REFERENCE_SUCCESS: {
      const entries = { ...state.fileReference.entries };
      delete entries[action.payload.id];
      return {
        ...state,
        openRequests : removeOpenRequest(action, state),
        updatedAt    : Date.now(),
        fileReference: {
          ...state.fileReference,
          entries: entries,
        },
      };
    }

    case CREATE_FILE_REFERENCE_FAILURE:
    case DELETE_FILE_REFERENCE_FAILURE:
    case UPDATE_FILE_REFERENCE_FAILURE:
    case FIND_FILE_REFERENCE_FAILURE:
    case FIND_FILE_REFERENCES_FAILURE:
    case SEARCH_FILE_REFERENCES_FAILURE:
      return {
        ...state,
        openRequests  : removeOpenRequest(action, state),
        failedRequests: [ ...state.failedRequests, action.type ],
        updatedAt     : Date.now(),
      };


    default:
      return state;
  }
};
